<div class="full-height full-width flex column align-center justify-center no-data">
  <h2 *ngIf="currentShop && !disableWelcome"
      class="margin-bottom">Welcome to {{currentShop.name}}</h2>
  <h4 class="bold-text custom-margin">{{subTitle || '- Page coming soon -'}}</h4>
  <img [ngClass]="{'small-image':small}"
       src="assets/back-office/images/coming-soon-dark.svg">
</div>
